export default __webpack_public_path__ + "static/mobile-bg-round-analytic-bd53757a9a2b6574d19b11296e1ce0d4.svg";